export const supportedLocales = {
    en: "English",
    sp: "Español",
    tr: "Türkçe",
    "fr-CA": "Français (Canada)",
};

export const fallbackLocale = "en";